import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({
        isAuthenticated: false,
        user: null,
    });

    const login = (user) => {
        // Set user info and authentication status
        setAuth({
            isAuthenticated: true,
            user,
        });
    };

    const logout = () => {
        // Clear user info and authentication status
        setAuth({
            isAuthenticated: false,
            user: null,
        });
    };

    return (
        <AuthContext.Provider value={{ auth, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);